<template>
    <div class="container">
        <Title text="Pratiche" v-bind:backArrow="false" />
        <div class="searchbar-container">
            <SearchBar 
                :case="'laboratori'"
                @pratiche="searchPratiche"
            />
        </div>
        <div class="list-container">
            <div class="loader-container" v-if="!loaded">
                <div class="loader"></div>
            </div>
            <b-list-group v-if="loaded">
                <b-list-group-item v-if="!pratiche.length" variant="secondary"><span>Non è ancora stata creata alcuna pratica.</span></b-list-group-item>
                <b-list-group-item button class="d-flex justify-content-between align-items-center list-item" v-for="pratica in pratiche" :key="pratica.uid" @click="goToPratica(pratica)">
                    <span> {{pratica.nome}}</span>
                    <span><small>Data di prescrizione: </small> {{format_date(pratica.data_prescrizione)}}</span>
                </b-list-group-item>
            </b-list-group>
        </div>
    </div>
</template>

<script>

import Title from "@/components/Title.vue";
import SearchBar from "@/components/Search-Bar.vue";
import { mixins } from "@/mixins";


export default {
    name: "DashboardLab",
    data () {
        return {
            pratiche: Array,
            pazienti_list:[],
            loaded: false,
        }
    },
    mixins: [mixins],
    mounted () {
        this.$axios
            .get(this.$apibase + '/api/pratica/?ordering=-data_prescrizione', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                    this.pratiche = response.data;
                    this.loaded = true;
                })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
    },
    methods: {
        goToPratica: function(pratica){
            this.$router.push('/pratica/' + pratica.nome + '~' + pratica.uid);
        },
        searchPratiche: function(searchResult){
            this.pratiche = searchResult.sort((a, b) => (Date.parse(b.data_prescrizione) - Date.parse(a.data_prescrizione)));;
        },
    },
    components: {
        Title,
        SearchBar
    }

}
</script>


<style scoped>
    .container{
    width: 70%;
    max-width: 800px;
    }
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    .list-container{
        padding-top:60px;
    }

    .link {
        text-decoration: none;
        cursor: pointer;
    }

    /* .subtitle{
        text-align: right;
        width: 100%;
    } */

</style>